import axios from "axios";
import { getHeaders, URL } from "./config";
export const getAllCustomers = async (
    page,
    search,
    pageSize,
    type,
    callback
) => {
    const headers = await getHeaders();
    const url = type === 'requests' 
        ? `${URL}/getCustomers?page=${page}&searchTerm=${search}&pageSize=${pageSize}&requests=true`
        : `${URL}/getCustomers?page=${page}&searchTerm=${search}&pageSize=${pageSize}&customerType=${type}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getAllVendors = async (page, search, pageSize, callback) => {
    const headers = await getHeaders();
    let searchTerm = encodeURIComponent(search)
    const url = `${URL}/getVendors?page=${page}&searchTerm=${searchTerm}&pageSize=${pageSize}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getAllPurchaseOrders = async (
    page,
    search,
    pageSize,
    status,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/getPurchaseOrders?page=${page}&searchTerm=${search}&pageSize=${pageSize}&status=${status}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getAllQuotes = async (
    page,
    search,
    pageSize,
    status,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/getQuotes?page=${page}&searchTerm=${search}&pageSize=${pageSize}&status=${status}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getAllProducts = async (
    page,
    search,
    pageSize,
    status,
    callback,
    searchType = "",
    isComplete = null
) => {
    const headers = await getHeaders();
    let url = `${URL}/getProducts?page=${page}&pageSize=${pageSize}&searchTerm=${search}&status=${status}${searchType ? `&searchType=${searchType}` : ""}`;
    if (isComplete !== null) {
        url += `&isComplete=${isComplete}`;
    }
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getAllManufacturers = async (page = 1, search = "", pageSize = 50, callback) => {
    const headers = await getHeaders();
    let searchTerm = encodeURIComponent(search || "");
    const url = `${URL}/getManufacturers?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}`;
    axios
        .get(url, { headers: headers })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            axios
                .post(url, {}, { headers: headers })
                .then((response) => {
                    if (response?.data) {
                        callback({ status: 200, data: response?.data, success: true });
                    }
                })
                .catch((err2) => {
                    callback({ status: 400, message: err2?.response?.data?.message || err2?.message });
                });
        });
};
export const getProductsByManufacturer = async (
    mfg_id,
    page,
    pageSize,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/getProductsByManufacturer?mfg_id=${mfg_id}&page=${page}&limit=${pageSize}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getAllReturnOrders = async (
    page,
    search,
    pageSize,
    status,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/getReturnOrders?page=${page}&pageSize=${pageSize}&searchTerm=${search}&return_status=${status}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getAllCategories = async (page, search, pageSize, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getCategories?page=${page}&pageSize=${pageSize}&searchTerm=${encodeURIComponent(search || "")}`;
    axios
        .get(url, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            axios
                .post(url, {}, { headers: headers })
                .then((response) => {
                    if (response?.data) {
                        callback({ status: 200, data: response?.data, success: true });
                    }
                })
                .catch((err2) => {
                    callback({ status: 400, message: err2?.response?.data?.message || err2?.message });
                });
        });
};
export const getAllSubCategories = async (page, search, pageSize, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getSubCategories?page=${page}&pageSize=${pageSize}&searchTerm=${encodeURIComponent(search || "")}`;
    axios
        .get(url, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            axios
                .post(url, {}, { headers: headers })
                .then((response) => {
                    if (response?.data) {
                        callback({ status: 200, data: response?.data, success: true });
                    }
                })
                .catch((err2) => {
                    callback({ status: 400, message: err2?.response?.data?.message || err2?.message });
                });
        });
};

export const getAllSaleOrders = async (
    startDate,
    endDate,
    critical,
    status,
    paymentStatus,
    page,
    pageSize,
    searchTerm,
    sortOrder,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/getSaleOrders?startDate=${startDate}&endDate=${endDate}&showCritical=${critical}&status=${status}&paymentStatus=${paymentStatus}&pageSize=${pageSize}&page=${page}&searchTerm=${searchTerm}&sortOrder=${sortOrder}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getCustomerOrders = async (customerId, page, pageSize, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getOrdersByCustomerId?customer_id=${customerId}&page=${page}&pageSize=${pageSize}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getVendorOrders = async (vendorId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getPurchaseOrdersByVendorId?vendorId=${vendorId}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getTrackingOfOrders = async (orderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getTrackingByOrderId?orderId=${orderId}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getPurchaseOrdersReturnOrders = async (orderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getPurchaseOrdersByOrderId?orderId=${orderId}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getDashboardStats = async (mode, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getDashboardStats?mode=`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getSaleOrderDetails = async (orderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getSaleOrderDetails?orderId=${orderId}`;
    axios
        .get(url, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            axios
                .post(url, {}, { headers: headers })
                .then(async (response) => {
                    if (response?.data) {
                        callback({ status: 200, data: response?.data });
                    }
                })
                .catch((err2) => {
                    callback({ status: 400, message: err2?.message || error?.message });
                });
        });
};
export const checkCustomerPoUnique = async (
    customerPo,
    excludeOrderId,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/checkCustomerPoUnique`;
    axios
        .post(url, { number: customerPo, excludeOrderId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.response?.data?.message });
        });
};
export const TransferProductsFromOneMfgToOther = async (from, to, callback) => {
    try {
        const headers = await getHeaders();
        const url = `${URL}/transferManufacturerProducts`;

        axios
            .post(url, { from_mfg_id: from, to_mfg_id: to }, { headers })
            .then((response) => {
                if (response?.data) {
                    callback({ status: 200, data: response.data });
                } else {
                    callback({ status: 400, message: "No response data found." });
                }
            })
            .catch((error) => {
                callback({
                    status: error?.response?.status || 400,
                    message:
                        error?.response?.data?.message ||
                        "Something went wrong while transferring products.",
                });
            });
    } catch (error) {
        callback({
            status: 500,
            message: "Internal error while setting up the transfer request.",
        });
    }
};
export const checkProductSkuUniqueAPI = async (
    sku,
    excludeProductId,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/checkProductSkuUnique`;
    axios
        .post(url, { sku: sku, excludeProductId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data?.message });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.response?.data?.message });
        });
};
export const checkVendorDomainAPI = async (
    email,
    excludeVendorId,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/checkVendorEmailUnique`;
    axios
        .post(url, { email: email, excludeVendorId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data?.message });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.response?.data?.message });
        });
};
export const MergeProductsApi = async (from, to, callback) => {
    try {
        const headers = await getHeaders();
        const url = `${URL}/mergeProducts`;

        axios
            .post(url, { fromProductId: from, toProductId: to }, { headers })
            .then((response) => {
                if (response?.data) {
                    callback({ status: 200, data: response.data });
                } else {
                    callback({ status: 400, message: "No response data found." });
                }
            })
            .catch((error) => {
                callback({
                    status: error?.response?.status || 400,
                    message:
                        error?.response?.data?.message ||
                        "Something went wrong while transferring products.",
                });
            });
    } catch (error) {
        callback({
            status: 500,
            message: "Internal error while setting up the transfer request.",
        });
    }
};

export const MergeVendorsApi = async (from, to, callback) => {
    try {
        const headers = await getHeaders();
        const url = `${URL}/mergeVendors`;

        axios
            .post(url, { fromVendorId: from, toVendorId: to }, { headers })
            .then((response) => {
                if (response?.data) {
                    callback({ status: 200, data: response.data });
                } else {
                    callback({ status: 400, message: "No response data found." });
                }
            })
            .catch((error) => {
                callback({
                    status: error?.response?.status || 400,
                    message:
                        error?.response?.data?.message ||
                        "Something went wrong while merging vendors.",
                });
            });
    } catch (error) {
        callback({
            status: 500,
            message: "Internal error while setting up the merge request.",
        });
    }
};
export const getProductsBySubCategory = async (
    subcategory_id,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/getProductsBySubCategory?subCategoryId=${subcategory_id}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getProductsByCategory = async (
    category_id,
    callback
) => {
    const headers = await getHeaders();
    const url = `${URL}/getProductsByCategory?categoryId=${category_id}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const getProductSpecificationAPI = async (payload, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getProductSpecification`;
    axios
        .post(url, payload, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.response?.data?.error || error?.message });
        });
};

export const getManufacturerDistributors = async (sku, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getManufacturerDistributors?sku=${sku}`;
    axios
        .get(url, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({
                status: 400,
                message: error?.response?.data?.message || error?.message,
            });
        });
};

export const getIncompleteProducts = async (pageSize, page, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getIncompleteProducts?pageSize=${pageSize}&page=${page}`;
    axios
        .get(url, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({
                status: 400,
                message: error?.response?.data?.message || error?.message,
            });
        });
};

export const MergeCustomersApi = async (from, to, callback) => {
    try {
        const headers = await getHeaders();
        const url = `${URL}/mergeCustomers`;

        axios
            .post(url, { fromCustomerId: from, toCustomerId: to }, { headers })
            .then((response) => {
                if (response?.data) {
                    callback({ status: 200, data: response.data });
                } else {
                    callback({ status: 400, message: "No response data found." });
                }
            })
            .catch((error) => {
                callback({
                    status: error?.response?.status || 400,
                    message:
                        error?.response?.data?.message ||
                        "Something went wrong while merging customers.",
                });
            });
    } catch (error) {
        callback({
            status: 500,
            message: "Internal error while setting up the merge request.",
        });
    }
};

export const updateUserWhitelistAPI = async (userId, customerIds, action, selectAll = false, callback) => {
    try {
        const headers = await getHeaders();
        const url = `${URL}/updateUserWhitelist`;

        axios
            .post(url, { userId, customerIds, action, selectAll }, { headers })
            .then((response) => {
                if (response?.data) {
                    callback({ status: 200, data: response.data });
                } else {
                    callback({ status: 400, message: "No response data found." });
                }
            })
            .catch((error) => {
                callback({
                    status: error?.response?.status || 400,
                    message:
                        error?.response?.data?.message ||
                        "Something went wrong while updating user whitelist.",
                });
            });
    } catch (error) {
        callback({
            status: 500,
            message: "Internal error while setting up the request.",
        });
    }
};

export const getUserWhitelistAPI = async (userId, callback) => {
    try {
        const headers = await getHeaders();
        const url = `${URL}/getUserWhitelist?userId=${userId}`;

        axios
            .get(url, { headers })
            .then((response) => {
                if (response?.data) {
                    callback({ status: 200, data: response.data });
                } else {
                    callback({ status: 400, message: "No response data found." });
                }
            })
            .catch((error) => {
                callback({
                    status: error?.response?.status || 400,
                    message:
                        error?.response?.data?.message ||
                        "Something went wrong while fetching user whitelist.",
                });
            });
    } catch (error) {
        callback({
            status: 500,
            message: "Internal error while setting up the request.",
        });
    }
};

export const verifyWhitelistPropagationAPI = async (userId, fix, callback) => {
    try {
        const headers = await getHeaders();
        const url = `${URL}/verifyWhitelistPropagation?userId=${userId}&fix=${fix}`;

        axios
            .get(url, { headers })
            .then((response) => {
                if (response?.data) {
                    callback({ status: 200, data: response.data });
                } else {
                    callback({ status: 400, message: "No response data found." });
                }
            })
            .catch((error) => {
                callback({
                    status: error?.response?.status || 400,
                    message:
                        error?.response?.data?.message ||
                        "Something went wrong while verifying whitelist propagation.",
                });
            });
    } catch (error) {
        callback({
            status: 500,
            message: "Internal error while setting up the request.",
        });
    }
};

export const getShipmentTrackingAPI = async (page, pageSize, customer_id, trackingType, searchTerm, sortOrder, carrier, status, callback) => {
    try {
        const headers = await getHeaders();
        const url = `${URL}/getShipmentTracking?page=${page}&pageSize=${pageSize}&customer_id=${customer_id}&trackingType=${trackingType}&searchTerm=${encodeURIComponent(searchTerm)}&sortOrder=${sortOrder || 'desc'}&carrier=${carrier || ''}&status=${encodeURIComponent(status || '')}`;
        axios
            .get(url, { headers: headers })
            .then((response) => {
                if (response?.data) {
                    callback({ status: 200, data: response.data });
                } else {
                    callback({ status: 400, message: "No response data found." });
                }
            })
            .catch((error) => {
                callback({
                    status: error?.response?.status || 400,
                    message: error?.response?.data?.message || error?.message || "Something went wrong",
                });
            });
    } catch (error) {
        callback({
            status: 500,
            message: "Internal error while setting up the request.",
        });
    }
};

export const resolveTrackingManuallyAPI = async (trackingId, callback) => {
    try {
        const headers = await getHeaders();
        const url = `${URL}/resolveTrackingManually`;
        axios
            .post(url, { trackingId }, { headers })
            .then((response) => {
                if (response?.data) {
                    callback({ status: 200, data: response.data });
                } else {
                    callback({ status: 400, message: "No response data found." });
                }
            })
            .catch((error) => {
                callback({
                    status: error?.response?.status || 400,
                    message: error?.response?.data?.message || error?.message || "Something went wrong",
                });
            });
    } catch (error) {
        callback({
            status: 500,
            message: "Internal error while setting up the request.",
        });
    }
};
